// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-pull-refresh.empty[data-v-421a6380],.van-pull-refresh.empty .van-list[data-v-421a6380]{height:100%}", ""]);
// Exports
module.exports = exports;
